import { render, staticRenderFns } from "./YuboyaNavbar.vue?vue&type=template&id=79fc5487&scoped=true&"
import script from "./YuboyaNavbar.vue?vue&type=script&lang=ts&"
export * from "./YuboyaNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./YuboyaNavbar.vue?vue&type=style&index=0&id=79fc5487&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fc5487",
  null
  
)

export default component.exports